export const environment = {
    production: true,
    apiOrigin: 'https://tm.dreamstep.in'
};
